// Console log in dev mode
export const trace = (...str) => {
  const body = document.querySelector("body")
  if (body.dataset.mode == "dev") {
    console.log(...str)
  }
}


// ### Color related helpers ###
const componentToHex = (c) => {
  const hex = c.toString(16)
  return hex.length == 1 ? "0" + hex : hex
}
// RGB to HEX
export const rgbToHex = (r, g, b) => {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b)
}
// HEX to RGB
export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null
}